import vueAuthInstance from '@/services/auth.js'

export default {
  state: {
    uid: null,
    eid: window.localStorage.getItem('eid') || null,
    email: null,
    profile: {},
    isAuthenticated: vueAuthInstance.isAuthenticated(),
    universe: {}
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated
    },

    setProfile(state, payload) {
      state.profile = payload.profile
    },

    setUid(state, uid) {
      state.uid = uid
    },

    setEid: (state, eid) => {
      window.localStorage.setItem('eid', eid)
      state.eid = eid
    },

    setEmail(state, email) {
      state.email = email
    },

    setCompanyId(state, companyId) {
      state.companyId = companyId
    },

    setUniverse(state, payload) {
      const themeClass = payload && payload.theme ? payload.theme : 'moova'
      document.documentElement.className = themeClass
      document.getElementById('app').className = themeClass
      if (payload) {
        let universe
        if (process.env.ENV_FLAG !== 'local' && document.querySelectorAll('[data-name=' + payload.theme + ']').length < 1) {
          const timestamp = document.querySelector('meta[name=timestamp]').content
          const themeLink = document.createElement('link')
          themeLink.href = '/static/css/' + payload.theme + '.' + timestamp + '.css'
          themeLink.type = 'text/css'
          themeLink.rel = 'stylesheet'
          themeLink.dataset.name = payload.theme
          document.getElementsByTagName('head')[0].appendChild(themeLink)
        }
        if (window.countries && window.countries.length > 0 && !payload.merged) {
          const countryUniverseOverride = window.countries.findIndex(x => x.iso_code === window.$cookies.get('country')) !== -1 ? window.countries.find(x => x.iso_code === window.$cookies.get('country')).front_config.universe : {}
          if (countryUniverseOverride) {
            universe = { ...payload, ...countryUniverseOverride, ...{ merged: true } }
          }
        }
        state.universe = universe || payload
      }
    }
  },
  getters: {
    uid: state => {
      return state.uid
    },
    eid: state => {
      return state.eid
    },
    profile: state => {
      return state.profile
    },
    email: state => {
      return state.email
    },
    company_id: state => {
      return state.companyId
    },
    universe: state => {
      return state.universe
    }
  },

  actions: {
    login(context, payload) {
      payload = payload || {}
      return vueAuthInstance.login(payload.user, payload.requestOptions).then(response => {
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
        const uid = vueAuthInstance.getPayload() ? vueAuthInstance.getPayload().sub : null
        context.commit('setUid', uid)
        if (response.body.ecosystem_id) {
          context.commit('setEid', response.body.ecosystem_id)
        }
      })
    },

    register(context, payload) {
      payload = payload || {}
      return vueAuthInstance.register(payload.user, payload.requestOptions).then(function () {
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      })
    },

    logout(context, payload) {
      payload = payload || {}
      payload.requestOptions = vueAuthInstance.options
      return vueAuthInstance.logout(payload.requestOptions).then(function () {
        context.commit('setUid', null)
        context.commit('setEmail', null)
        context.commit('setCompanyId', null)
        context.commit('setProfile', {})
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      })
    },

    authenticate(context, payload) {
      payload = payload || {}
      return vueAuthInstance.authenticate(payload.provider, payload.userData, payload.requestOptions).then(function () {
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    setUniverse(context, payload) {
      context.commit('setUniverse', payload)
    },

    setEid(context, payload) {
      context.commit('setEid', payload)
    }
  }
}
